module.exports = __webpack_public_path__ + "static/media/FIA_Logo-20250916-193022.c525d39df4736fb3d6cf8ad22f8f93e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FIA_Logo-20250916-193022.png
// module id = 1108
// module chunks = 1